<div class="container single-view" id="add-item">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" routerLink="/items/" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'ITEMS.BTN_BACK_TO_ITEMS' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="add-item-title" class="section-title">{{ 'ITEM_CREATE.TITLE' | translate }}</h1>
          <p data-testid="add-item-subtitle"class="section-subtitle mt-1 text-base">{{ 'ITEM_CREATE.SUBTITLE' | translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <form class="mt-0" [formGroup]="itemForm" data-testid="add-item-form">
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 class="border-b pb-3">{{ 'ITEM_CREATE.ITEM_DETAILS' | translate }}</h2>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                  <label data-testid="add-item-field-product" class="block text-sm" for="productId">
                    {{ 'ITEM_CREATE.PRODUCT' | translate }} <i class="icon-required-field"></i>
                  </label>
                  <app-custom-dropdown
                    data-testid="product"
                    [placeholder]="'ITEM_CREATE.SELECT_PRODUCT_PLACEHOLDER' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="comboData.rowsPerPageOption || 5"
                    [totalCount]="comboData.totalRecords"
                    [totalPages]="getComboTotalPages()"
                    [options]="comboData.list"
                    formControlName="productId"
                    (onLazyLoad)="onLazyLoadComboData($event)">
                  </app-custom-dropdown>
                  @if (itemForm.get('productId')?.invalid && itemForm.get('productId')?.touched) {
                    <small data-testid="product-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3"
                  [ngClass]="{ 'disabled': (itemForm.get('serialNumber')?.disabled ?? false) }">

                  <label data-testid="add-item-field-serialnumber" class="block text-sm mb-2" for="serialNumber">
                    {{ 'ITEM_CREATE.SERIAL_NUMBER' | translate }}
                    @if (serialNumberRequired) {
                      <i class="icon-required-field"></i>
                    }
                  </label>

                  <div class="flex items-stretch camera-btn-field-wr">
                    <input data-testid="add-item-serialnumber-input" type="text" class="flex-1 w-full" id="serialNumber"
                      formControlName="serialNumber" autocomplete="off">

                    <textbox-camera class="shrink-0 self-stretch flex items-center"
                      (qrCodeScanned)="qrCodeScanned($event)"
                      [disabled]="(itemForm.get('serialNumber')?.disabled ?? true)">
                    </textbox-camera>
                  </div>

                  @if (itemForm.get('serialNumber'); as sn) {
                    @if ((sn.touched || sn.dirty)) {
                      @if (serialNumberRequired && sn.hasError('required')) {
                        <small data-testid="serialnumber-mandatory" class="p-error"
                          >
                          {{ 'FORMS.MANDATORY_FIELD' | translate }}
                        </small>
                      }
                      @if (sn.hasError('maxlength')) {
                        <small class="p-error">
                          {{ 'FORMS.FIELD_LENGTH_EXCEEDED' | translate }}
                        </small>
                      }
                      @if (sn.pending) {
                        <small class="p-info">
                          {{ 'FORMS.VALIDATING_SN' | translate }}
                        </small>
                      }
                      @if (sn.hasError('serialNumberSold')) {
                        <small class="p-error">
                          {{ 'SALE_CREATE.SERIAL_NUMBER_ALREADY_SOLD' | translate }}
                        </small>
                      }
                      @if (sn.hasError('serialNumberExists')) {
                        <small class="p-error">
                          {{ 'SALE_CREATE.SERIAL_NUMBER_ALREADY_EXISTS' | translate }}
                        </small>
                      }
                      @if (sn.hasError('productRequiredForSerial')) {
                        <small class="p-error">
                          {{ 'ITEM_CREATE.PRODUCT_REQUIRED_FOR_SERIAL_NUMBER' | translate }}
                        </small>
                      }
                      @if (sn.hasError('serialValidationFailed')) {
                        <small class="p-error">
                          {{ 'SALE_CREATE.ERROR_VALIDATING_SERIAL_NUMBER' | translate }}
                        </small>
                      }
                    }
                  }
                </div>

                @if (showSecurityCodeField) {
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                    <label data-testid="add-item-field-securitycode" class="block text-sm" for="securityCode">{{ 'ITEM_CREATE.SECURITY_CODE' | translate }}</label>
                    <input data-testid="add-item-securitycode-input" type="text" id="securityCode" formControlName="securityCode" autocomplete="off">
                  </div>
                }

                @if (showSecurityCodeVersionField) {
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                    <label data-testid="add-item-field-securitycodeversion" class="block text-sm" for="securityCodeVersion">{{ 'ITEM_CREATE.SECURITY_CODE_VERSION' |
                    translate }}</label>
                    <input data-testid="add-item-securitycodeversion-input"  type="text" id="securityCodeVersion" formControlName="securityCodeVersion"
                      autocomplete="off">
                  </div>
                }

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                  <label data-testid="add-item-field-productiondate" class="block text-sm" for="productionDate">{{ 'ITEM_CREATE.PRODUCTION_DATE' | translate
                  }}</label>
                  <p-datepicker data-testid="add-item-productiondate-input" class="w-100" id="productionDate" formControlName="productionDate" dateFormat="dd-mm-yy"
                    [maxDate]="currentDate" placeholder="{{ 'ITEM_CREATE.DATE_PLACEHOLDER' | translate }}"
                    showIcon="true" [showTime]="false" appendTo="body" />
                </div>

                @if (isPrepairedCompany) {
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                    <div class="row">
                      <div class="col-12">
                        <span class="label text-sm">{{ 'ITEM_CREATE.IMPLICIT_CODE_PAIRING' | translate }}</span>
                        <label data-testid="add-item-implicitcodepairing-yes-label" class="inline-flex mr-6">
                          <p-radioButton data-testid="add-item-implicitcodepairing-yes" name="implicitCodePairing" value="true" formControlName="implicitCodePairing"
                            inputId="implicit-code-pairing-yes" />
                          <span for="implicit-code-pairing-yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                        </label>
                        <label data-testid="add-item-implicitcodepairing-no-label" class="inline-flex mr-2">
                          <p-radioButton data-testid="add-item-implicitcodepairing-no" name="implicitCodePairing" value="false" formControlName="implicitCodePairing"
                            inputId="implicit-code-pairing-no" />
                          <span for="implicit-code-pairing-no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  @if (itemForm.get('implicitCodePairing')?.value === 'false') {
                    <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                      <label data-testid="add-item-field-warrantycode" class="block text-sm" for="warrantyCode">{{ 'ITEM_CREATE.PREPAIRED_CODE' | translate }} <i
                      class="icon-required-field"></i></label>
                      <input data-testid="add-item-warrantycode-input" type="text" id="warrantyCode" formControlName="warrantyCode" autocomplete="off">
                      @if (itemForm.get('warrantyCode')?.touched) {
                        @if (itemForm.get('warrantyCode')?.errors?.['maxlength']) {
                          <small class="p-error">
                            {{ 'FORMS.FIELD_LENGTH_EXCEEDED' | translate }}
                          </small>
                        }
                        @if (itemForm.errors?.['requiredPrepaired'] && isPrepairedCompany) {
                          <small data-testid="warrantycode-mandatory" class="p-error">
                            {{ 'FORMS.MANDATORY_FIELD' | translate }}
                          </small>
                        }
                      }
                    </div>
                  }
                }

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                  <label data-testid="add-item-field-warrantyduration" class="block text-sm" for="warrantyDurationMonths">{{ 'ITEM_CREATE.WARRANTY_DURATION' |
                    translate }} <i class="pi pi-question-circle"
                  pTooltip="{{ 'TOOLTIP.DURATION_IN_MONTHS' | translate }}" tooltipPosition="top"></i></label>
                  <input data-testid="add-item-warrantyduration-input" type="number" id="warrantyDurationMonths" formControlName="warrantyDurationMonths"
                    autocomplete="off">
                  @if (
                    itemForm.get('warrantyDurationMonths')?.invalid &&
                    itemForm.get('warrantyDurationMonths')?.touched
                  ) {
                    <small data-testid="warrantyduration-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                @if (companyHasCpo) {
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                    <div class="row">
                      <div class="col-12">
                        <span class="label text-sm">{{ 'ITEM_CREATE.REFURBISHED_CPO' | translate }}</span>
                        <label data-testid="add-item-cpo-yes-label" class="inline-flex mr-6">
                          <p-radioButton data-testid="add-item-cpo-yes" name="isCpo" value="true" formControlName="isCpo" inputId="cpo-yes" />
                          <span for="cpo-yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                        </label>
                        <label data-testid="add-item-cpo-no-label" class="inline-flex mr-2">
                          <p-radioButton data-testid="add-item-cpo-no" name="isCpo" value="false" formControlName="isCpo" inputId="cpo-no" />
                          <span for="cpo-no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                }
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                  <div class="row">
                    <div class="col-12">
                      <span class="label text-sm">{{ 'ITEM_CREATE.GENUINE_PRODUCT' | translate }}</span>
                      <label data-testid="add-item-genuine-yes-label"  class="inline-flex mr-6">
                        <p-radioButton data-testid="add-item-genuine-yes"  name="isGenuine" value="true" formControlName="isGenuine"
                          inputId="genuine-yes" />
                        <span for="genuine-yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                      </label>
                      <label data-testid="add-item-genuine-no-label"  class="inline-flex mr-2">
                        <p-radioButton data-testid="add-item-genuine-no" name="isGenuine" value="false" formControlName="isGenuine"
                          inputId="genuine-no" />
                        <span for="genuine-no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mt-6 mb-4 pt-8 border-t">
                  <div class="flex items-center justify-end gap-3">
                    <button data-testid="add-item-create-item-button" type="button" class="btn primary-btn"
                      [disabled]="itemForm.invalid" (click)="submitForm()">
                      {{ 'ITEM_CREATE.BTN_ADD_NEW_ITEM' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
